import { atom } from 'jotai';

export const commonLanguageAtom = atom<Record<string, string>>({});

export const homeLanguageAtom = atom<Record<string, string>>({});
